const VirtualQuoteSection = () => {
  return (
    <section className="py-24 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-['Poppins']">
            Instant Estimates — Powered by AI
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Skip the in-person appointments and get accurate pricing in seconds. Our technology measures your roof and matches you with pros instantly.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#4A90E2]/10 rounded-xl mb-6">
              <i className="ri-smartphone-line text-3xl text-[#4A90E2]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Submit Your Address</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Enter your property address and answer a few quick questions about your roofing needs. No photos required for instant estimates.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#4A90E2]/10 rounded-xl mb-6">
              <i className="ri-flashlight-line text-3xl text-[#4A90E2]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">AI Measures Your Roof</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Our advanced AI technology measures your roof in seconds using satellite imagery and generates accurate square footage calculations.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-[#4A90E2]/10 rounded-xl mb-6">
              <i className="ri-team-line text-3xl text-[#4A90E2]"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Match With Vetted Pros</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Get connected with top-rated local contractors who offer fair pricing. Review your options and connect when you're ready.
            </p>
          </div>
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 lg:p-12 shadow-sm">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4 font-['Poppins']">
                Why Instant Estimates Work Better
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Traditional roofing quotes require scheduling multiple appointments with different contractors, taking time off work, and dealing with pushy sales tactics. Our instant estimate system gives you accurate pricing immediately and connects you only with pros who match your needs.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#4A90E2] text-xl mr-3 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">Get pricing in seconds, not days or weeks</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#4A90E2] text-xl mr-3 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">No pressure from salespeople at your door</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#4A90E2] text-xl mr-3 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">AI-powered accuracy matches in-person estimates</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#4A90E2] text-xl mr-3 mt-0.5"></i>
                  <span className="text-gray-700 text-sm">Connect directly with pros — no middleman fees</span>
                </li>
              </ul>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/202cde88909422c208ad99089f9a546d.jpg"
                alt="Instant Roof Estimate Technology"
                className="w-full h-[400px] object-cover object-top rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VirtualQuoteSection;
